import React from 'react';

/**
 * Renderiza el bloque VersusSettings de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function VersusSettings({
  v
}) {
  return v.drVs ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "padding": "0 0.740741vh 0 0.925926vh",
      "height": "7.037037vh",
      "flex": "none",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, React.createElement("button", {
    "onClick": v.drBack,
    "title": "Volver al menú",
    style: {
      "width": "1.666667vw",
      "height": "2.962963vh",
      "border": "0",
      "background": "transparent",
      "color": "#8793a6",
      "cursor": "pointer",
      "fontSize": "1.666667vh",
      "borderRadius": "0.555556vh"
    },
    className: "scapp-full-hover"
  }, v.text("‹")), React.createElement("span", {
    style: {
      "flex": "1",
      "font": "italic 700 1.666667vh 'IBM Plex Sans',sans-serif",
      "color": "#e4e9f0"
    }
  }, v.text("V/S")), React.createElement("button", {
    "onClick": v.closeDrawer,
    "title": "Cerrar",
    style: {
      "width": "1.875vw",
      "height": "3.333333vh",
      "border": "0",
      "background": "transparent",
      "color": "#8793a6",
      "cursor": "pointer",
      "fontSize": "1.851852vh",
      "borderRadius": "0.555556vh"
    },
    className: "scapp-full-hover"
  }, v.text("×"))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.111111vh",
      "padding": "1.481481vh 1.666667vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "fontWeight": "600"
    }
  }, v.text("Selección para comparar")), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(v.vsHint))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "alignItems": "center",
      "gap": "0.555556vh 0",
      "minHeight": "2.222222vh"
    }
  }, (v.vsPendChips || []).map((c, index165) => React.createElement(React.Fragment, {
    key: index165
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center"
    }
  }, c.vs ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "margin": "0 0.740741vh",
      "font": "italic 700 1.111111vh 'IBM Plex Sans',sans-serif",
      "color": "oklch(0.66 0.19 42)"
    }
  }, v.text("v/s"))) : null, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.37037vh",
      "padding": "0.185185vh 0.37037vh 0.185185vh 0.740741vh",
      "border": "0.092593vh solid rgba(184,193,206,0.2)",
      "borderRadius": "0.462963vh",
      "flex": "none",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.740741vh",
      "borderRadius": "0.185185vh",
      "background": c.c
    }
  }, null), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(c.n)), React.createElement("button", {
    "onClick": c.rm,
    "title": "Quitar",
    style: {
      "border": "0",
      "background": "transparent",
      "color": "#8793a6",
      "cursor": "pointer",
      "fontSize": "1.203704vh",
      "padding": "0 0.277778vh",
      "lineHeight": "1"
    }
  }, v.text("×"))))))), v.text("\n        "), React.createElement("button", {
    "onClick": v.vsApply,
    style: {
      "height": "3.148148vh",
      "border": "0",
      "borderRadius": "0.555556vh",
      "background": "oklch(0.66 0.19 42)",
      "color": "#fff",
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "opacity": v.vsApplyOp
    }
  }, v.text("Comparar selección")), v.text("\n      ")), v.text("\n      "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "overflow": "auto",
      "display": "flex",
      "flexDirection": "column",
      "padding": "0.555556vh 0"
    }
  }, (v.vsList || []).map((x, index166) => React.createElement(React.Fragment, {
    key: index166
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "height": "3.888889vh",
      "padding": "0 1.666667vh",
      "flex": "none"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(x.n)), React.createElement("button", {
    "onClick": x.click,
    style: {
      "width": "3.645833vw",
      "height": "2.407407vh",
      "borderRadius": "0.462963vh",
      "border": "0.092593vh solid " + x.bd,
      "background": x.bg,
      "color": x.color,
      "font": "italic 600 1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer"
    }
  }, v.text(x.lab)))))), v.text("\n    "))) : null;
}
